import { FieldErrors, FieldValues } from "react-hook-form";
import { staticText } from "../../../statics/static-text";
import { isFieldErrorWithTypes } from "./password-rules/PasswordRules.Parts";

// TEXT
export const text = staticText.inputs.password;

// STYLES

// DATA

// TYPES
export type Props = {
  passwordLabel?: string;
  confirmPasswordLabel?: string;
};

// CONSTANTS

// FUNCTIONS
export const getPasswordErrorMessage = (
  errors: FieldErrors<FieldValues>[number],
) => {
  if (errors?.types && isFieldErrorWithTypes(errors)) {
    if (
      Array.isArray(errors.types["too_small"]) &&
      errors.types["too_small"].some(
        (msg: string) => msg === text.newPassword.validation.rules.required,
      )
    ) {
      return errors?.message?.toString();
    } else if (Object.keys(errors.types).length > 0) {
      return text.newPassword.validation.invalid;
    }
  }
};

// ASSETS
